import { render, staticRenderFns } from "./Povstani1848.vue?vue&type=template&id=699f1253&"
import script from "./Povstani1848.vue?vue&type=script&lang=js&"
export * from "./Povstani1848.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports